import React, { useEffect, useState } from "react";
import logo from "../../assets/images/homePage/Piku_Token_Set.png";
import back from "../../assets/images/homePage/coin_background.png";
import arrow from "../../assets/images/homePage/chevron-right.svg";
import usdc from "../../assets/images/homePage/USDC.svg";
import usdt from "../../assets/images/homePage/USDT.svg";
import dai from "../../assets/images/homePage/DAI.svg";
import Calque from "../../assets/images/homePage/Swissquote.svg";
import ave from "../../assets/images/homePage/capital.svg";
import seearrow from "../../assets/images/homePage/home_right_arrow.png";
import avax from "../../assets/images/homePage/AVAX.svg";
import eth from "../../assets/images/homePage/ETH.svg";
import btc from "../../assets/images/homePage/BTC.svg";
import res_arrow from "../../assets/images/homePage/reserve_arrow.svg";
import copy from "../../assets/images/homePage/reserve_wallet_copy.svg";
import useTranslation from "../../Languages/Translation";
import { getPikuPrice, getPikuPriceHome } from "../../Service/Web3/Web3Service";

function CoinSection() {
  const [tab, settab] = useState("1");
  const [copied, setCopied] = useState(null);
  const [pikuPrice, setPikuPrice] = useState(1);


  const copyToClipboard = (code, i) => {
    navigator.clipboard.writeText(code)
    setCopied(i)
  }

  useEffect(() => {
    const fetchData = async () => {
      let price = await getPikuPriceHome()
      setPikuPrice(price)
    }
    setTimeout(() => {
      setCopied(null);
    }, 1000);
    fetchData();
  }, [copied]);

  const bitcoinlist = [
    {
      image: btc,
      title: "BTC Network",
      code: "0x00AdA75Fatest4018",
    },
    {
      image: eth,
      title: "ETH Network",
      code: "0x00AdA75Fatest4019",
    },
    {
      image: avax,
      title: "AVAX Network",
      code: "0x00AdA75Fatest4020",
    },
  ];

  const tablelist = [
    {
      image: usdc,
      title: "USDC",
      code: "On Chain",
      percent: '20%'
    },
    {
      image: dai,
      title: "DAI",
      code: "On Chain",
      percent: '15%'
    },
    {
      image: usdt,
      title: "USDT",
      code: "On Chain",
      percent: '15%'
    },
    {
      image: Calque,
      title: "US Treasury Swissquote",
      code: "On Chain",
      percent: '15%'
    },
    {
      image: ave,
      title: "US Treasury Capital Union",
      code: "On Chain",
      percent: '5%'
    },
  ];

  const translation = useTranslation();

  return (
    <div className=" main_container pt-[40px] md:pt-[63px] pb-[30px] md:pb-[80px]">

      {/* coin section */}

      <div className="bg-white rounded-[24px] p-[2px] relative overflow-hidden">
        <div className="flex items-center justify-between border border-black rounded-[24px] p-[24px] md:p-[32px]">
          <img src={back} alt="back" className="hidden md:block absolute right-0"></img>
          <div>
            <p className="text-black text-[18px] aeonik_normal">
              STABLECOIN VALUE
            </p>
            <div className=" flex items-center pt-[12px] pb-[4px]">
              <img src={logo} alt="logo"></img>
              <p className="text-[20px] md:text-[32px] pl-[5px] md:pl-[12px] pr-[8px] aeonik_bold text-black">
                1 PIKU = ${parseFloat(pikuPrice).toFixed(2)}
              </p>
              <a
                href=""
                className="rounded-[12px] border-[1.5px] border-black aeonik_medium text-[12px] px-[7px] py-[2px]"
              >
                Yield Info
              </a>
            </div>
            <p className="text-black text-[16px] aeonik_normal">
              Backing Yield 7% + PikuG Airdrop
            </p>
          </div>
          <a
            href=""
            className="rounded-[150px] border border-black z-10 mt-2 md:mt-0 bg-white px-[10px] py-[5px] md:px-[23px] md:py-[10px]"

          >
            <img src={arrow} alt="arrow"></img>
          </a>
        </div>
      </div>

      {/* table section */}

      <div className="pt-[46px] flex items-center justify-between">
        <p className="text-[#fff] aeonik_medium text-[24px] md:text-[32px]">
          {translation.ReserveBackingDistribution}
        </p>
        <div className=" flex items-center rounded-[10px] bg-[#1a1c1d] p-[4px]">
          <div
            onClick={() => settab("1")}
            className={`${tab === "1" && "bg-[#fff]"
              } rounded-[6px] py-[3px] cursor-pointer px-[6px]`}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.75 6.75H20.25M3.75 12H20.25M3.75 17.25H20.25"
                stroke={`${tab === "1" ? "#010304" : "#fff"}`}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            onClick={() => settab("2")}
            className={`${tab === "2" && "bg-[#fff]"
              } rounded-[6px] py-[5px] px-[8px] cursor-pointer`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.875 11.25C1.875 7.45304 4.95304 4.375 8.75 4.375C9.09518 4.375 9.375 4.65482 9.375 5V10.625H15C15.3452 10.625 15.625 10.9048 15.625 11.25C15.625 15.047 12.547 18.125 8.75 18.125C4.95304 18.125 1.875 15.047 1.875 11.25Z"
                fill={`${tab === "2" ? "#010304" : "#fff"}`}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.625 2.5C10.625 2.15482 10.9048 1.875 11.25 1.875C15.047 1.875 18.125 4.95304 18.125 8.75C18.125 9.09518 17.8452 9.375 17.5 9.375H11.25C10.9048 9.375 10.625 9.09518 10.625 8.75V2.5Z"
                fill={`${tab === "2" ? "#010304" : "#fff"}`}
              />
            </svg>
          </div>
        </div>
      </div>

      <table className="w-full my-[32px]">
        <thead className="bg-[#1c2023] h-[30px] ">
          <tr>
            <th className="pl-[10px] md:pl-[30px] rounded-l-[8px] text-left aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">
              RATE
            </th>
            <th className=" text-left pl-[10px] aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">
              CRYPTO
            </th>
            <th className=" pr-[10px] text-left rounded-r-[8px] aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">
              TRANSACTIONS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr><td className=" pt-[16px]"></td></tr>
          {tablelist?.map((m, i) => (
            <tr className="border border-b-[#1a1c1d]" key={i}>
              <td className="text-white text-[14px] md:text-[18px] pl-[10px] md:pl-[30px]  py-[16px] aeonik_bold">
                {m.percent}
              </td>
              <td className=" py-[16px] pl-[10px]">
                <div className="flex items-center">
                  <img src={m.image} alt="usdc"></img>
                  <p className="text-white text-[14px] md:text-[18px] pl-[8px] aeonik_normal">
                    {m.title}
                  </p>
                </div>
              </td>
              <td className="text-white py-[16px] text-[14px] md:text-left text-end aeonik_normal">
                {m.code}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <a
        href=""
        className="flex items-start pl-[24px] text-[18px] leading-[27px] text-white aeonik_medium"
      >
        <span className="mr-[4px]">{translation.SeeAll}</span>
        <img
          src={seearrow}
          alt="see"
          className="h-[20px] w-auto object-contain  transform rotate-90"
        />
      </a>

      {/* wallet Address section */}

      <div className="mt-[30px] md:mt-[64px]">
        <p className=" text-white aeonik_medium text-[24px] md:text-[32px] pb-[24px]">
          {translation.ReserveWalletAddress}
        </p>
        <div className="grid grid-cols-12 gap-x-[15px] lg:gap-x-[32px]">
          {bitcoinlist?.map((m, i) => (

            <div
              key={i}
              className="col-span-12 mb-5 lg:mb-0 md:col-span-6 lg:col-span-4 p-[32px] border border-black rounded-[24px] ReserveWallet_gradiant outline outline-2 outline-offset-2 outline-[#32353B]"
            >
              <div className=" flex items-center justify-between">
                <div className="flex items-center">
                  <img src={m.image} alt="btc"></img>
                  <p className="text-white aeonik_medium text-[18px] pl-[8px]">
                    {m.title}
                  </p>
                </div>
                <a href="" className="p-[16px] rounded-full bg-white">
                  <img
                    src={res_arrow}
                    alt="arrow"
                    className="h-[13px] w-auto object-contain"
                  />
                </a>
              </div>
              <div className="flex items-center mt-5 md:mt-[48px]">
                <p
                  id="name"
                  className="text-[18px] text-white aeonik_normal leading-[23px] mr-[16px]"
                >
                  {m.code.substring(0, 11)}....{m.code.substr(m.code?.length - 4)}
                </p>
                <img
                  alt="arrow"
                  className="h-[24px] w-auto object-contain cursor-pointer mr-[16px]"
                  id="name"
                  src={copy}
                  onClick={() => copyToClipboard(m?.code, i)}
                />
                {copied === i ? <span className="text-white ">Copied!</span> : ""}

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CoinSection;
